import type {ApiEntity, UserFacingEntity} from './types';

export const getUserEntityFromApiType = (entityType: ApiEntity): UserFacingEntity => {
    switch (entityType) {
        case 'Accounts':
            return 'company';
        case 'Contacts':
            return 'person';
        case 'Leads':
        default:
            return 'lead';
    }
};
